export default {"src":"/_next/static/media/crown_v3.a66a2a64.svg","height":33,"width":38,"blurWidth":0,"blurHeight":0};